export default {
  scrs: ['/scrs-bigScreen', '/monitorScreen']
}
